export const headerConfig = {
  AUTH_SITE_URL: `${process.env.REACT_APP_AUTH_URL}/`,
  GFG_UD_URL_CF: process.env.REACT_APP_AUTH_UTIL_URL,
  GFG_UD_URL_ORIGIN: `${process.env.REACT_APP_AUTH_UTIL_ORIGIN_URL}/api/`,
  PRACTICE_SITE_URL: `${process.env.REACT_APP_PHP_BACKEND_URL}/`,
  GFG_SITE_URL: `${process.env.REACT_APP_GFG_SITE_URL}/`,
  PRACTICE_API_URL: `${process.env.REACT_APP_DJANGO_API_URL_ONLY}/`,
  AUTH_DJANGO_API_URL: `${process.env.REACT_APP_AUTH_DJANGO_API_URL}/`,
  isLocalhost: process.env.REACT_APP_ENVIRONMENT.toUpperCase() === "LOCALHOST",
  authToken: process.env.NEXT_PUBLIC_AUTH_TOKEN,
  domain: "practice",
  postId: null,
  GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  ONE_TAP_URL: `${process.env.REACT_APP_AUTH_DJANGO_API_URL}/google-verify/`,
  NOTIFICATION_API_URL: `${process.env.REACT_APP_HEADER_NOTIFICATION_API_URL}/`,
};

export const stickyStyles = {
  position: "sticky",
  top: "0px",
  "z-index": "950",
};
